<template>
  <div class="row">
    <div class="col-12 mx-0 px-0">
      <div class="intro">
        <h1 class="intro__headline">Walentynka wysłana!</h1>
        <h1 class="intro__headline__secondary">Zaproś innych do zabawy</h1>
        <ShareLinks/>
        <h1 class="intro__headline__secondary">Wesprzyj ochronę przyrody</h1>
        <div class="v__text">
          <p style="margin-left:10%;margin-right:10%;">
            Zawalczmy wspólnie o ochronę starych lasów, o gatunki chronione, o owady zapylające i zwiększenie obszarów chronionych w naszym kraju. 
            Pomóż nam w tym - razem mamy wielką moc!
          </p>
        </div>

        <div class="form__submit font-bold justify-content-center" style="display:block!important;width:fit-content;justify-content:center;margin-left: auto;margin-right:auto;"
             onclick="location.href='https://wspieram.greenpeace.pl/lp/przyroda?fundraiser=walentynka2025'">
          <span>Wspieram!</span>
        </div>
        <br><br>
      </div>
    </div>
  </div>
</template>

<script>
import ShareLinks from "@/components/ShareLinks.vue";

export default {
  name: "Intro",
  inject: ["content"],
  components: {
    ShareLinks,
  },
  data() {
    return {
      title: "Introduction",
    };
  },
  methods: {},
};
</script>
